var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(Array.isArray(_vm.details.objects)) ? _c('div', {
    staticClass: "archive-details"
  }, [_c('div', {
    staticClass: "archive-details__header"
  }, [_c('h2', {
    staticClass: "archive-details__title title is-4 is-marginless",
    domProps: {
      "innerHTML": _vm._s(_vm.titleText(_vm.details))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "archive-details__close-icon",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "archive-details__body"
  }, [(_vm.details.caption) ? _c('div', {
    staticClass: "archive-details__body__row is-fullwidth",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.details.caption))
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.details.objects), function(object, objIndex) {
    return _c('div', {
      key: ("obj-" + objIndex),
      staticClass: "archive-details__body__row",
      attrs: {
        "data-index": objIndex + 1
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.imagePath(object)
      }
    }), _vm._v(" "), _c('div', {}, [_c('h2', {
      staticClass: "title is-5"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.titleText(object))
      }
    }), _vm._v(", " + _vm._s(_vm.displayDate(object)))]), _vm._v(" "), _c('h3', {
      staticClass: "subtitle is-6"
    }, [_vm._v(_vm._s(_vm.displayType(object)))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.descriptionText(object))
      }
    }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "is-size-7",
      domProps: {
        "innerHTML": _vm._s(_vm.tombstoneText(object))
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1, true)])])
  })], 2)]) : _c('div', {
    staticClass: "archive-details"
  }, [_c('div', {
    staticClass: "archive-details__header"
  }, [_c('h2', {
    staticClass: "archive-details__title title is-4 is-marginless"
  }), _vm._v(" "), _c('a', {
    staticClass: "archive-details__close-icon",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "archive-details__body"
  }, [_c('div', {
    staticClass: "archive-details__body__row"
  }, [_c('div', [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.imagePath(_vm.details)
    }
  })]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "title is-5"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.titleText(_vm.details))
    }
  }), _vm._v(", " + _vm._s(_vm.displayDate(_vm.details)))]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle is-6"
  }, [_vm._v(_vm._s(_vm.displayType(_vm.details)))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.descriptionText(_vm.details))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3)])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-md-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light"
  }, [_vm._v("View Object")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-outlined"
  }, [_vm._v("View in Getty Collection")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion ion-md-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-outlined"
  }, [_vm._v("View Object")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light is-outlined"
  }, [_vm._v("View in Getty Collection")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec497ac2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArchiveDetails.vue
// module id = j1Am
// module chunks = 0